import styled from "styled-components";
import {
  FakeLink,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
} from "../../../../constants/Styles";

export const BarcodeLink = styled.a`
  font-variant-numeric: tabular-nums;
`;

export const BarcodeFakeLink = styled(FakeLink)`
  font-variant-numeric: tabular-nums;
`;

export const ContainerToolsTitle = styled.div`
  font-size: ${FONT_SIZE.size24};
  font-weight: ${FONT_WEIGHT.weight700};
  font-family: ${FONTS.spaceGrotesk};
  font-variant-numeric: tabular-nums;
`;

export const ContainerTools = styled.div`
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  width: 100%;
  padding: 1rem;
`;

export const HorizontalList = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;
